<template>
  <v-card>
    <div class="pa-4">
      <h4>Creator Type</h4>
    </div>
    <v-divider></v-divider>
    <div class="pa-4">
      <v-chip-group>
        <v-chip v-for="(type, k) of creator_type" :key="k" x-small>{{
          type
        }}</v-chip>
      </v-chip-group>
      <div v-if="creator_type.length == 0">
        <p class="ma-0">No Creator Type Yet</p>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "CreatorType",
  props: ["creator_type"],
};
</script>

<style></style>
